module.exports = __webpack_public_path__ + "static/media/hotel-receptionist.994d50d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/sliderPuzzle/hotel-receptionist.png
// module id = 523
// module chunks = 0